const LINKS = {
  404: '/404/',
  500: '/500/',
  ABOUT_US: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/sobre-nos/`,
  AME_SELECTION: '/promocoes/selecao/ame/',
  APP_DOWNLOAD: 'https://promobit.onelink.me/OPOZ/g38ldz5y',
  BADGES_AND_LEVELS: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br//profile/medalhas-e-niveis/`,
  HIGH_OFFERS: '/promocoes/em-alta/',
  BLOG: '/blog/',
  BUSINESS: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/Index/parcerias/`,
  COMMUNITY_GUIDELINES: '/diretrizes-da-comunidade/',
  COMPARAI: 'https://www.comparai.com.br/',
  CONTACT_US: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/Index/contato/`,
  COOKIES_POLICY: `/institucional/cookies/`,
  COUPONS: '/cupons/',
  FAQ: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/Index/faq/`,
  FORUM: '/forum/',
  FREE_OFFERS: '/promocoes/gratis/',
  HOME: '/',
  IDINHEIRO: 'https://www.idinheiro.com.br/',
  INTERNATIONAL_OFFERS: '/promocoes/selecao/doubleeleven/',
  LANDING_APPS: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/ofertas/app-ofertas/`,
  LANDING_CONSUMER_DAY: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/dia-do-consumidor/`,
  LANDING_MOTHERS_DAY: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/dia-das-maes/`,
  LAST_COUPONS: '/cupons/ultimos-cupons/',
  LOWEST_PRICE: '/promocoes/menor-preco/',
  MEDIA: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/Index/imprensa/`,
  MELHOR_PLANO: 'https://melhorplano.net/',
  MELIUZ: 'https://www.meliuz.com.br/',
  MESSAGES: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/central/mensagens/`,
  MINHA_CONEXAO: 'https://www.minhaconexao.com.br/',
  NEW_COUPON: `/cupons/novo-cupom/`,
  NEW_FEATURES:
    'https://feedback.userreport.com/b6b783e4-2f37-4673-8222-2d0547d468ff/#ideas/popular',
  NEW_OFFER: `/promocoes/nova-oferta/`,
  NEW_TESTERS: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/ofertas/novo-testers`,
  NEW_THREAD: `/forum/novo-topico/`,
  NOTIFICATIONS: '/notificacoes',
  PICODI_BR: 'https://www.picodi.com/br/',
  PROFILE: `/`,
  PROMOBIT_COUPONS: '/cupons/promobit',
  PROMOBIT_EXTENSION:
    'https://chrome.google.com/webstore/detail/promobit-cupons/nhibeafmnmfmipihndekfnnmmacldkfk?hl=pt-BR',
  PROMOBIT_WHAT_IS: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/o-que-e-promobit/`,
  PURCHASE_ISSUES: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/Index/compra-segura/`,
  SEARCH: '/buscar/',
  SENDING_OFFERS: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/Index/cadastrando/`,
  SETTINGS: `https://${process.env.NEXT_PUBLIC_LEGACY_PAGES_TEMP_SUBDOMAIN}.promobit.com.br/central/configuracoes`,
  SITEMAP: '/mapa-site/',
  STORES: '/lojas/',
  TRAVEL: '/promocoes/viagem/',
  WORK_WITH_US: 'https://promobit.gupy.io/',
};

export default LINKS;
